/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSpinner,
  CButton,
  CLabel,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ResourceCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      user: {},
      loading: false,
      optionsGroup: [{ value: null, name: "Carregando" }],
      creating: false,
      group_id: null,
      description: "",
      code: "",
      submitButton: false
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ creating: true });

    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respGroup => {
          const optionsGroup = [];
          respGroup.data.data.forEach(group => {
            optionsGroup.push({ value: group.id, name: group.name });
          });

          this.setState({ optionsGroup });
        },
        error => {
          this.error("Não foi possível listar os grupos");
        }
      );

    const { id } = this.props.match.params;

    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}education/resource/list`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              if (resp.data.success) {
                // eslint-disable-next-line eqeqeq
                let current = resp.data.data.find(
                  item => item.id === parseInt(id)
                );
                this.setState(
                  () => ({
                    region: current,
                    description: current.description,
                    code: current.code,
                    group_id: current.group_id
                  }),
                  () => {
                    this.setState(() => ({
                      edit: true,
                      loading: false
                    }));
                  }
                );
              }
            });
        }
      );
    } else {
      this.setState({ group_id: this.props.general.active_roles.group_id });
    }
  }

  enviar(value) {
    // this.setState({ creating: true });
    this.setState({ submitButton: true });

    let obj = {
      //   loggedUser: this.props.user.user.id,
      description: value.description,
      code: value.code,
      group_id: this.state.group_id
    };

    axios
      .post(`${URL.api}education/resource/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/education/resource/list");
          this.setState({ creating: false, submitButton: false });
        },
        () => {
          this.error("Não foi possível criar o recurso");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  atualizar(value) {
    // this.setState({ creating: true });
    this.setState({ submitButton: true });
    let obj = {
      //   loggedUser: this.props.user.user.id,
      description: value.description,
      code: value.code,
      group_id: this.state.group_id
    };

    const { id } = this.props.match.params;

    axios
      .post(`${URL.api}education/resource/update/${id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/education/resource/list");
          this.setState({ creating: false, submitButton: false });
        },
        () => {
          this.error("Não foi possível atualizar o recurso");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  render() {
    const Fields = [
      {
        name: "description",
        label: "Descrição",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "code",
        label: "Código Padronizado",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    return (
      <>
        {/* Ajeitar o BreadCrumb  */}
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            { path: "/education/method/list", to: "/education/method/list" }
          ]}
        />
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Recurso" : "Criar Recurso"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o recurso selecionado"
                    : "Crie um novo recurso"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={!this.state.creating}
              >
                <>
                  <span style={this.state.submitButton ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.submitButton && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={Fields}
                ref={this.formRef}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.region}
                edit={this.state.edit}
              />
              {["G"].includes(this.props.general.active_roles.type) && (
                <CFormGroup>
                  <CLabel>Grupo</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-group"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      className="flex-1"
                      value={this.state.group_id}
                      onChange={e =>
                        this.setState({
                          group_id: parseInt(e.target.value),
                          region_id: null,
                          school_id: null
                        })
                      }
                      disabled={
                        this.props.general.active_roles.group_id !== null
                      }
                    >
                      <option value={null}>Grupo</option>
                      {this.state.optionsGroup.map(group => (
                        <option value={group.value}>{group.name}</option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                </CFormGroup>
              )}
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceCreate);
